<template>
  <span class="badge" :class="badgeClass">{{ label }}</span>
</template>

<script setup>
import {computed, defineProps} from 'vue';

const props = defineProps({
  status: {
    type: String,
    default: null
  },
  label: {
    type: String,
    required: true
  }
})

const statusClassMap = {
  new: 'badge-info-inverted',
  in_allocation: 'badge-warning-inverted',
  approval_pending: 'badge-warning-inverted',
  active: 'badge-success-inverted',
  accepted: 'badge-primary-inverted',
  finished: 'badge-danger-inverted'
}

const badgeClass = computed(() => statusClassMap[props.status] || 'badge-default-inverted')
</script>

<style scoped>
.badge {
  font-weight: 600;
  padding: 5px 10px;
  border-radius: 4px;
}
</style>
